import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./style.scss";
import { Nav } from "reactstrap";
import PerfectScrollbar from "perfect-scrollbar";
import routes from "routes.js";
import { useHistory } from "react-router-dom";
var ps;

function Sidebar(props) {
  const history = useHistory();
  const sidebar = React.useRef();
  const [brandName, setbrandName] = useState();

  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(sidebar.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
    };
  });

  const getBrand = () => {
    routes.map((prop, key) => {
      if (window.location.href.indexOf(prop.layout + prop.path) !== -1) {
        setbrandName(prop.name);
      }
      return null;
    });
  };

  useEffect(() => {
    getBrand();
  });

  const openSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
  };

  const logoutFunction = () => {
    history.push("/login")
    localStorage.removeItem("accessTokenDash")
    localStorage.removeItem("UseridDash")
    localStorage.removeItem("refreshTokenDash")
  }

  return (
    <div
      className="sidebar"
      data-color={props.bgColor}
      data-active-color={props.activeColor}
    >
      <div className="logo for-mobilesidebar-sm">
        <Link to="/admin/dashboard" className="simple-text logo-mini ">
          <div className="logo-img text-left">
            <img src="\Logo.svg" alt="react-logo" />
          </div>
        </Link>
        <img src="\assets\main-assets\x-close.svg" alt="img" className="img-fluid img-close d-none" onClick={() => openSidebar()} />
      </div>
      <div className="sidebar-wrapper" ref={sidebar}>
        <Nav>
          <li>
            <Link
              to={`/admin/market`}
              className={
                "nav-link " + (brandName === "All Market" ? "active" : "")
              }
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <path d="M12 23.5907C8 23.5907 4.75 20.7207 4.75 17.1907V13.4907C4.75 13.0807 5.09 12.7407 5.5 12.7407C5.91 12.7407 6.25 13.0807 6.25 13.4907C6.25 16.1107 8.72 18.0907 12 18.0907C15.28 18.0907 17.75 16.1107 17.75 13.4907C17.75 13.0807 18.09 12.7407 18.5 12.7407C18.91 12.7407 19.25 13.0807 19.25 13.4907V17.1907C19.25 20.7207 16 23.5907 12 23.5907ZM6.25 17.3007C6.32 19.9507 8.87 22.0907 12 22.0907C15.13 22.0907 17.68 19.9507 17.75 17.3007C16.45 18.7107 14.39 19.5907 12 19.5907C9.61 19.5907 7.56 18.7107 6.25 17.3007Z" fill="#D5FF2F" />
                <path d="M12 14.5906C9.24 14.5906 6.75999 13.3506 5.54999 11.3506C5.02999 10.5006 4.75 9.51058 4.75 8.49058C4.75 6.77058 5.52 5.15058 6.91 3.93058C8.27 2.74058 10.08 2.09058 12 2.09058C13.92 2.09058 15.72 2.74058 17.09 3.92058C18.48 5.15058 19.25 6.77058 19.25 8.49058C19.25 9.51058 18.97 10.4906 18.45 11.3506C17.24 13.3506 14.76 14.5906 12 14.5906ZM12 3.59058C10.44 3.59058 8.98001 4.11058 7.89001 5.07058C6.83001 5.99058 6.25 7.21058 6.25 8.49058C6.25 9.24058 6.44999 9.94058 6.82999 10.5706C7.77999 12.1306 9.76 13.0906 12 13.0906C14.24 13.0906 16.22 12.1206 17.17 10.5706C17.56 9.94058 17.75 9.24058 17.75 8.49058C17.75 7.21058 17.17 5.99058 16.1 5.05058C15.01 4.11058 13.56 3.59058 12 3.59058Z" fill="#D5FF2F" />
                <path d="M12 19.5906C7.87 19.5906 4.75 16.9706 4.75 13.4906V8.49058C4.75 4.96058 8 2.09058 12 2.09058C13.92 2.09058 15.72 2.74058 17.09 3.92058C18.48 5.15058 19.25 6.77058 19.25 8.49058V13.4906C19.25 16.9706 16.13 19.5906 12 19.5906ZM12 3.59058C8.83 3.59058 6.25 5.79058 6.25 8.49058V13.4906C6.25 16.1106 8.72 18.0906 12 18.0906C15.28 18.0906 17.75 16.1106 17.75 13.4906V8.49058C17.75 7.21058 17.17 5.99058 16.1 5.05058C15.01 4.11058 13.56 3.59058 12 3.59058Z" fill="#D5FF2F" />
              </svg>
              <p className="ttttt">Markets</p>
            </Link>
          </li>
          <li>
            <Link
              to={`/admin/dashboard`}
              className={
                "nav-link " + (brandName === "Dashboard" ? "active" : "")
              }
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <path d="M12 23.5907C8 23.5907 4.75 20.7207 4.75 17.1907V13.4907C4.75 13.0807 5.09 12.7407 5.5 12.7407C5.91 12.7407 6.25 13.0807 6.25 13.4907C6.25 16.1107 8.72 18.0907 12 18.0907C15.28 18.0907 17.75 16.1107 17.75 13.4907C17.75 13.0807 18.09 12.7407 18.5 12.7407C18.91 12.7407 19.25 13.0807 19.25 13.4907V17.1907C19.25 20.7207 16 23.5907 12 23.5907ZM6.25 17.3007C6.32 19.9507 8.87 22.0907 12 22.0907C15.13 22.0907 17.68 19.9507 17.75 17.3007C16.45 18.7107 14.39 19.5907 12 19.5907C9.61 19.5907 7.56 18.7107 6.25 17.3007Z" fill="#D5FF2F" />
                <path d="M12 14.5906C9.24 14.5906 6.75999 13.3506 5.54999 11.3506C5.02999 10.5006 4.75 9.51058 4.75 8.49058C4.75 6.77058 5.52 5.15058 6.91 3.93058C8.27 2.74058 10.08 2.09058 12 2.09058C13.92 2.09058 15.72 2.74058 17.09 3.92058C18.48 5.15058 19.25 6.77058 19.25 8.49058C19.25 9.51058 18.97 10.4906 18.45 11.3506C17.24 13.3506 14.76 14.5906 12 14.5906ZM12 3.59058C10.44 3.59058 8.98001 4.11058 7.89001 5.07058C6.83001 5.99058 6.25 7.21058 6.25 8.49058C6.25 9.24058 6.44999 9.94058 6.82999 10.5706C7.77999 12.1306 9.76 13.0906 12 13.0906C14.24 13.0906 16.22 12.1206 17.17 10.5706C17.56 9.94058 17.75 9.24058 17.75 8.49058C17.75 7.21058 17.17 5.99058 16.1 5.05058C15.01 4.11058 13.56 3.59058 12 3.59058Z" fill="#D5FF2F" />
                <path d="M12 19.5906C7.87 19.5906 4.75 16.9706 4.75 13.4906V8.49058C4.75 4.96058 8 2.09058 12 2.09058C13.92 2.09058 15.72 2.74058 17.09 3.92058C18.48 5.15058 19.25 6.77058 19.25 8.49058V13.4906C19.25 16.9706 16.13 19.5906 12 19.5906ZM12 3.59058C8.83 3.59058 6.25 5.79058 6.25 8.49058V13.4906C6.25 16.1106 8.72 18.0906 12 18.0906C15.28 18.0906 17.75 16.1106 17.75 13.4906V8.49058C17.75 7.21058 17.17 5.99058 16.1 5.05058C15.01 4.11058 13.56 3.59058 12 3.59058Z" fill="#D5FF2F" />
              </svg>
              <p className="ttttt">Chains</p>
            </Link>
          </li>

          <li>
            <Link
              to={`/admin/pairs`}
              className={
                "nav-link " + (brandName === "Pairs" ? "active" : "")
              }
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <path d="M12 23.5907C8 23.5907 4.75 20.7207 4.75 17.1907V13.4907C4.75 13.0807 5.09 12.7407 5.5 12.7407C5.91 12.7407 6.25 13.0807 6.25 13.4907C6.25 16.1107 8.72 18.0907 12 18.0907C15.28 18.0907 17.75 16.1107 17.75 13.4907C17.75 13.0807 18.09 12.7407 18.5 12.7407C18.91 12.7407 19.25 13.0807 19.25 13.4907V17.1907C19.25 20.7207 16 23.5907 12 23.5907ZM6.25 17.3007C6.32 19.9507 8.87 22.0907 12 22.0907C15.13 22.0907 17.68 19.9507 17.75 17.3007C16.45 18.7107 14.39 19.5907 12 19.5907C9.61 19.5907 7.56 18.7107 6.25 17.3007Z" fill="#D5FF2F" />
                <path d="M12 14.5906C9.24 14.5906 6.75999 13.3506 5.54999 11.3506C5.02999 10.5006 4.75 9.51058 4.75 8.49058C4.75 6.77058 5.52 5.15058 6.91 3.93058C8.27 2.74058 10.08 2.09058 12 2.09058C13.92 2.09058 15.72 2.74058 17.09 3.92058C18.48 5.15058 19.25 6.77058 19.25 8.49058C19.25 9.51058 18.97 10.4906 18.45 11.3506C17.24 13.3506 14.76 14.5906 12 14.5906ZM12 3.59058C10.44 3.59058 8.98001 4.11058 7.89001 5.07058C6.83001 5.99058 6.25 7.21058 6.25 8.49058C6.25 9.24058 6.44999 9.94058 6.82999 10.5706C7.77999 12.1306 9.76 13.0906 12 13.0906C14.24 13.0906 16.22 12.1206 17.17 10.5706C17.56 9.94058 17.75 9.24058 17.75 8.49058C17.75 7.21058 17.17 5.99058 16.1 5.05058C15.01 4.11058 13.56 3.59058 12 3.59058Z" fill="#D5FF2F" />
                <path d="M12 19.5906C7.87 19.5906 4.75 16.9706 4.75 13.4906V8.49058C4.75 4.96058 8 2.09058 12 2.09058C13.92 2.09058 15.72 2.74058 17.09 3.92058C18.48 5.15058 19.25 6.77058 19.25 8.49058V13.4906C19.25 16.9706 16.13 19.5906 12 19.5906ZM12 3.59058C8.83 3.59058 6.25 5.79058 6.25 8.49058V13.4906C6.25 16.1106 8.72 18.0906 12 18.0906C15.28 18.0906 17.75 16.1106 17.75 13.4906V8.49058C17.75 7.21058 17.17 5.99058 16.1 5.05058C15.01 4.11058 13.56 3.59058 12 3.59058Z" fill="#D5FF2F" />
              </svg>
              <p className="ttttt">Pairs</p>
            </Link>
          </li>










        </Nav>
      </div>
      <div className="lastsidebar">
        <div className="endbtn">
          <button onClick={logoutFunction} className="del">Log Out</button>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
